import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import agTableVif from './agTableVif';
import { defaultBarChartVif } from './barChartVif';
import { defaultMapVif } from './mapVif';
import { defaultCalendarVif } from './calendarVif';
import { defaultColumnChartVif } from './columnChartVif';
import { defaultComboChartVif } from './comboChartVif';
import { defaultPieChartVif } from './pieChartVif';
import { defaultHistogramVif } from './histogramVif';
import { defaultScatterChartVif } from './scatterChartVif';
import { defaultTableVif } from './tableVif';
import { defaultDataTableVif } from './dataTableVif';
import { defaultTimelineChartVif } from './timelineChartVif';
import { type Vif } from 'common/visualizations/vif';
import { isTableHeaderWrapEnabled } from 'common/visualizations/helpers/VifSelectors';
import { isEmpty } from 'lodash';

/**
 * Configures wrapHeaders to TRUE for new tables and FALSE for existing tables
 * when enable_table_header_wrapping is enabled.
 */
export const createAgTableVif = (existingVif?: Partial<Vif>) => {
  const baseAgTableVif = cloneDeep(agTableVif);
  const formatting = get(existingVif, 'series[0].formatting');
  // Set wrapHeaders to TRUE by default only for new tables
  if (isEmpty(formatting) && isTableHeaderWrapEnabled()) {
    baseAgTableVif.series[0].formatting.headerFormat = {
      ...baseAgTableVif.series[0].formatting.headerFormat,
      wrapHeaders: true,
    };
  }
  return baseAgTableVif;
};

export default (vif?: Partial<Vif>) =>
  cloneDeep({
    barChart: defaultBarChartVif,
    map: defaultMapVif,
    calendar: defaultCalendarVif,
    columnChart: defaultColumnChartVif,
    comboChart: defaultComboChartVif,
    pieChart: defaultPieChartVif,
    histogram: defaultHistogramVif,
    scatterChart: defaultScatterChartVif,
    table: defaultTableVif,
    dataTable: defaultDataTableVif,
    agTable: createAgTableVif(vif),
    timelineChart: defaultTimelineChartVif,
  });
